"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _style = require("webmotors-react-pj/frame/footer/logged/date/style");
var _default = () => _react.default.createElement(_style.StyleText, null, "\xA9 1995-".concat(new Date().getFullYear(), " ").concat(_lang.default.footer.copyrights));
exports.default = _default;